import { sub, add } from "date-fns";

export default function useDateBeforeOrAfter({ isBefore, numberOfDays }) {
	const result = isBefore ? sub(new Date(), { days: numberOfDays }) : add(new Date(), { days: numberOfDays });

	return result;
}
